var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArroba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0207 9.93023C18.0207 5.85061 14.9284 3.01123 10.483 3.01123C5.87673 3.01123 2.71973 6.19848 2.71973 10.8515C2.71973 15.6544 5.79285 18.7 10.6425 18.7C11.8277 18.7 12.9649 18.5309 13.8105 18.2394V17.0541C13.2192 17.3277 11.9487 17.5051 10.6617 17.5051C6.63848 17.5051 4.04385 14.9201 4.04385 10.9079C4.04385 6.99736 6.68523 4.19648 10.3606 4.19648C14.1212 4.19648 16.6966 6.51748 16.6966 9.91098C16.6966 12.2237 15.9349 13.7184 14.7496 13.7184C14.0731 13.7184 13.6881 13.3334 13.6881 12.6734V7.15823H12.2691V8.30498H12.1179C11.7521 7.48686 10.9065 6.97948 9.91785 6.97948C7.99285 6.97948 6.6481 8.57723 6.6481 10.8611C6.6481 13.2495 7.96398 14.8569 9.91923 14.8569C11.0192 14.8569 11.8649 14.3206 12.2691 13.3622H12.4204C12.5317 14.2835 13.387 14.9407 14.487 14.9407C16.6485 14.9407 18.0207 12.9937 18.0207 9.93023ZM8.15235 10.8982C8.15235 9.25236 8.89485 8.27611 10.1544 8.27611C11.4331 8.27611 12.2499 9.29086 12.2499 10.8982C12.2499 12.5056 11.4235 13.53 10.1351 13.53C8.90448 13.53 8.15235 12.5331 8.15235 10.8982Z",
    fill: "#F8F8F8",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArroba);
export default __webpack_public_path__ + "static/media/arroba.1861a068e90da33ce910fd270d4a26c3.svg";
export { ForwardRef as ReactComponent };